import React from 'react';
import ArrowControllerBase from '../dist/ArrowControllerBase';
import { PokeRender } from "./PokeRender";

export default function ArrowController() {
  return (
    <ArrowControllerBase>
      {(content) => <PokeRender direction={content} />}
    </ArrowControllerBase>
  );
}